import $ from 'jquery'

export default class searchSuggestion {

  constructor() {
    this.input = document.querySelector('.js-suggestions')
    this.box = document.querySelector('.js-suggestion-box')
    this.clone = undefined
    this.query = ''
    this.timeout = undefined;

    if (!this.input && !this.box) return

    this.form = document.querySelector('.js-form')
    this.close = this.form.querySelector('.js-close')

    this.focusInHandler()
    this.inputHandler()
    this.clickHandler()
    this.submitForm()
    this.scrollHandler()
    this.resizeHandler()
  }

  submitForm () {
    this.form.addEventListener('submit', event => {
      event.preventDefault()
    })
  }

  getData () {
    $.get(ajax_object.ajax_url, {
      'action': 'suggestions',
      'query': this.query
    }, (response) => {
      this.remove()
      if (!this.query) {
        this.cloneBox()
        this.show(this.clone)
        return
      }
      this.toggle()
      this.fillBox(response.data, response.success)

    })
  }

  fillBox (data, success) {

    let string = ''

    data.forEach(topic => {
      if (success) {
        Object.keys(topic).forEach(id => {
          string += `<a href="${topic[id].link}#${topic[id].slug}" class="suggestion-list-item">
         <p class="suggestion-list-item-subject text-primary mb-0">${topic[id].topicTitle}</p>
         <p class="suggestion-list-item-title mb-0">${topic[id].faqTitle}</p>
         <p class="suggestion-list-item-description mb-0">${topic[id].description}</p>
         </a>`
        })
      } else {
        string += `<div class="suggestion-list-item no-data">
         <p class="suggestion-list-item-title mb-0">${topic.title}</p>
         </div>`
      }
    })

    this.clone.innerHTML = string

  }

  scrollHandler () {
    window.addEventListener('scroll', this.setPosition.bind(this))
  }

  resizeHandler () {
    window.addEventListener('resize', this.setPosition.bind(this))
  }

  focusInHandler () {
    this.input.addEventListener('focusin', this.handler.bind(this))
  }

  inputHandler () {
    this.input.addEventListener('input', event => {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        const {target: {value}} = event
        this.query = value
        this.getData()
      }, 300)
    })
  }

  clickHandler () {
    this.close.addEventListener('click', this.handler.bind(this))
    document.addEventListener('click', this.handler.bind(this))
  }

  setPosition () {
    if (!this.clone) return

    let offset = 10
    if (document.body.classList.contains('admin-bar')) {
      offset = -22
    }

    const pos = this.input.getBoundingClientRect()
    this.clone.style.left = pos.left + 'px'
    this.clone.style.width = pos.width + 'px'
    this.clone.style.top = pos.top + pos.height + offset + window.pageYOffset + 'px'

  }

  shouldClose (event) {
    const {type, target} = event
    const button = this.form.querySelector('button')
    const buttonContent = button.querySelector('img')
    const item = target.classList.contains('suggestion-list-item')
    const title = target.classList.contains('suggestion-list-item-title')
    const subject = target.classList.contains('suggestion-list-item-subject')
    const description = target.classList.contains('suggestion-list-item-description')

    return type === 'click' &&
      target !== this.input &&
      target !== this.clone &&
      target !== button &&
      target !== buttonContent &&
      !item && !title && !subject && !description
  }

  handler (event) {
    if (this.shouldClose(event)) {
      this.clear()
      this.remove()
      return
    }

    this.toggle()
  }

  toggle () {
    this.close.classList.remove('d-none')
    this.cloneBox()

    this.show(this.clone)
  }

  cloneBox () {
    if (this.clone !== undefined) return
    this.clone = this.box.cloneNode(true)
  }

  show (html) {
    const pos = this.input.getBoundingClientRect()

    let offset = 10
    if (document.body.classList.contains('admin-bar')) {
      offset = -22
    }

    html.style.postition = 'absolute'
    html.style.top = pos.top + pos.height + offset + window.pageYOffset + 'px'
    html.style.width = pos.width + 'px'
    html.style.left = pos.left + 'px'
    html.classList.remove('d-none')

    document.body.appendChild(html)
    document.body.classList.add('menu-active')
  }

  clear () {
    this.input.value = '';
    this.query = '';
  }

  remove () {
    if (!this.clone) return

    this.close.classList.add('d-none')
    document.body.removeChild(this.clone)
    document.body.classList.remove('menu-active')
    this.clone = undefined
  }

}
